import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "px-6 py-3"
}
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_5 = { class: "w-8/12 px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "text-neutral-500" }
const _hoisted_7 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_8 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_9 = { class: "text-center" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import PatientLayout from '../components/PatientLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import TabComponent from '@/components/TabComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from '@/components/PageLoader.vue';
import PagePagination from '@/components/PagePagination.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';

import { useRouter, useRoute } from 'vue-router';
import { ref, computed, onMounted, watch } from 'vue';
import { onIonViewWillEnter } from '@ionic/vue';
import { format } from 'date-fns';
import { startOfYear, endOfYear } from 'date-fns';
import { useNetworkStore } from '@/store/network';
import { paginatePage } from '@/helpers/PageHelper';
import ReportService from '@/classes/ReportService';
import Patient from '@/classes/Patient';
import { formatDateTime, formatDate } from '@/helpers/TimeFormatter'

import throttle from "lodash/throttle";
import AuthService from "@/classes/AuthService";

interface activeMember {
    Full_Name: string,
    Hospital_Number: string,
    Last_Login_At: Date,
}

interface Item {
    data: activeMember[]
    total: number
}



export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const patientId = ref(route.params.id);

// Data
const loader    = ref(true);
const showError = ref(false);
const errorMsg  = ref(null);

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

// Query
const searchText = ref();
const activeTab  = ref();
const goToPage   = ref();

// Page Renderer Data
const items       = ref(null);
const items_count = ref(0);
const query       = ref(null);

const tabs: { name: string, count: number, href: string, allowed: true }[] = [
    {
        name: 'Active',
        count: 0,
        href: '/accounts/dependents/bookings/' + patientId.value,
        allowed: true
    }
];

const headers: { text: string }[] = [
    { text: 'ID' },
    { text: 'Patient' },
    { text: 'Birthdate' },
    { text: 'Date Created'}
];

/**
 * ********************************
 * Methods 
 * ********************************
 */
 const indexDependents = (data: string) => {
    loader.value = true;

    if(isNetworkAvailable.value) {
        console.log("Online - Fetching Patient Dependents...")

        const pageNum = data?.match(/\d+/)[0] ? data?.match(/\d+/)[0] : 1;
        const queryString =  searchText.value ? `&query=${searchText.value}` : ''
        const additionalParam = `&page_number=${pageNum}&per_page=10&${queryString}&requested_at=${new Date().toISOString()}}`
    
        goToPage.value = data ? `page=${pageNum}` : 'page=1';
    
        Patient.fetchDependents(patientId.value, goToPage.value + additionalParam + `&patient_id=${patientId.value}`)
            .then((response: any) => {
                loader.value      = false;
                items.value       = response.data;
                items_count.value = response.data.total
                query.value       = response.data.query
            })
            .catch((err) => {
                loader.value    = false;
                showError.value = true;
                errorMsg.value  = err.response.data.message;
                
                if(err.response.status == 401) {
                    window.location.replace('/login');
                }
            })
    } else {
        console.log("Offline - Fetching Patient Dependents...")

        const pageNum = data?.match(/\d+/)[0] ? data?.match(/\d+/)[0] : 1;

        Patient.fetchDependents(patientId.value, `page=${pageNum}&page_number=${pageNum}&per_page=10&patient_id=${patientId.value}`)
        .then((response: any) => {
            loader.value      = false;
            items.value       = response.data;
            items_count.value = response.data.total
            query.value       = response.data.query
        })
        .catch(() => {
            loader.value    = false;
            showError.value = true;
            errorMsg.value = "Oppps... No available data was saved for offline use.";
        })
    }
}

watch(
    () => isNetworkAvailable.value,
    () => {
        indexDependents(goToPage.value);
    }
);

onMounted(() => {
    loader.value = true;
    setTimeout(() => {
        console.log('Mounted Hook - Network: ' + isNetworkAvailable.value);
        indexDependents(goToPage.value);
    }, 1000);
})

onIonViewWillEnter(() => {
    loader.value = true;
    setTimeout(() => {
        console.log('Mounted Hook - Network: ' + isNetworkAvailable.value);
        indexDependents(goToPage.value);
    }, 1000);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Dependents",
    "show-back": "",
    backUrl: `/accounts/patients`
  }, {
    default: _withCtx(() => [
      _createVNode(PatientLayout, { "patient-id": patientId.value }, {
        contents: _withCtx(() => [
          (isNetworkAvailable.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(TabComponent, {
                  tabs: tabs,
                  "button-items": true
                }, _createSlots({ _: 2 }, [
                  (isNetworkAvailable.value)
                    ? {
                        name: "buttons",
                        fn: _withCtx(() => [
                          _createVNode(ButtonComponent, {
                            class: "text-gray-900",
                            secondary: "",
                            exportBtn: "",
                            onClick: _ctx.exportData,
                            disabled: loader.value
                          }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode(" Export ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick", "disabled"])
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1024)
              ]))
            : _createCommentVNode("", true),
          (isNetworkAvailable.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(FilterComponent, {
                  search: searchText.value,
                  "onUpdate:searchText": _cache[0] || (_cache[0] = (value) => (searchText.value = value)),
                  "sidebar-filters": false,
                  "custom-filters": activeTab.value !== 'activity_logs'
                }, null, 8, ["search", "custom-filters"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(DataTable, {
              headers: headers,
              count: items.value?.total
            }, {
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item, key) => {
                  return (_openBlock(), _createElementBlock("tr", { key: key }, [
                    _createElementVNode("td", _hoisted_4, _toDisplayString(item.patient_id), 1),
                    _createElementVNode("td", _hoisted_5, [
                      _createTextVNode(_toDisplayString(item?.first_name) + " " + _toDisplayString(item?.last_name) + " ", 1),
                      _createElementVNode("p", _hoisted_6, _toDisplayString(item?.email), 1)
                    ]),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(formatDate)(item.birthdate)), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(formatDateTime)(item.created_date)), 1),
                    _createElementVNode("td", _hoisted_9, [
                      _createVNode(ActionButton, {
                        "edit-btn": "",
                        onClick: ($event: any) => (_unref(router).push(`/accounts/patients/show/${item.patient_id}?dependent=true`))
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["count"]),
            _createVNode(PagePagination, {
              class: "mb-6",
              items: items.value
            }, null, 8, ["items"])
          ])
        ]),
        _: 1
      }, 8, ["patient-id"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})